import { useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { exportArrayToExcel } from "../helpers/exportToExcelHelper";
import { FaFileExcel } from "react-icons/fa";

const ExportToExcelButton = ({ data, filename, fetchAllData }) => {
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    // If a fetchAllData function is provided, use it to get all records
    if (fetchAllData) {
      setLoading(true);
      try {
        const allData = await fetchAllData();
        exportArrayToExcel(allData, filename);
      } catch (error) {
        console.error("Failed to fetch all data for export:", error);
        // Fallback to current page data
        exportArrayToExcel(data, filename);
      } finally {
        setLoading(false);
      }
    } else {
      // Use the provided data directly
      exportArrayToExcel(data, filename);
    }
  };

  return (
    <Button onClick={handleExport} className="float-end mb-2" disabled={loading}>
      {loading ? (
        <>
          <Spinner animation="border" size="sm" className="me-2" />
          Exporting...
        </>
      ) : (
        <>
          <FaFileExcel className="mb-1 me-2" /> Export to Excel
        </>
      )}
    </Button>
  );
};

export default ExportToExcelButton;
